import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-execution-release-modal",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./execution-release-modal.component.html",
  styleUrl: "./execution-release-modal.component.scss",
})
export class ExecutionReleaseModalComponent {
  @Input()
  configs: any = [];

  @Input()
  releases: any = [];

  activeModal = inject(NgbActiveModal);
  selectedRelease: any;
  isDisabled: boolean = true;
  selectedFile: any;
  isActive: boolean = false;


  ngOnInit(){
    this.selectedRelease = this.releases.length > 0 ? this.releases[0] : null;
    this.validateForm();
  }

  onSelectionChange() {
    console.log("selected release",this.selectedRelease);
    this.validateForm();
  }
  
  start() {
    this.activeModal.close({
      value: this.selectedRelease,
    });
  }

  validateForm() {
    this.isDisabled = !this.selectedRelease;
  }
}
